import { useEffect, useRef, useState } from "react";

export interface CarouselOptions {
  length: number;
  interval?: number;
}

/**
 * 通用的轮播控制：自动播放、手动切换、暂停
 */
export default function useCarousel({ length, interval = 6000 }: CarouselOptions) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timer = useRef<number | null>(null);

  const go = (next: number) => {
    if (length === 0) return;
    setIndex(((next % length) + length) % length);
  };

  const next = () => go(index + 1);
  const prev = () => go(index - 1);

  useEffect(() => {
    if (paused || length <= 1) return undefined;
    timer.current = window.setTimeout(() => {
      setIndex((current) => (current + 1) % length);
    }, interval);
    return () => {
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, [index, paused, length, interval]);

  return { index, setIndex: go, next, prev, paused, setPaused };
}